
import { RiRefreshLine } from 'react-icons/ri';
import { Field, TextInput } from './../UiComponents/Ui';
import MultiSelectDropdown from '../MultiSelectDropdown';
import { useEffect, useState } from 'react';



const selectError = (err, fallback) =>
  typeof err === 'string' ? fallback : err?.label || err?.value || '';

const LoadState = ({ loading, error }) =>
  loading ? (
    <RiRefreshLine size={12} className="text-primary-800 animate-spin-slow" />
  ) : error ? (
    <span className="text-xs text-error-600">Something went wrong</span>
  ) : null;

const AddressFields = ({
  addressKey,
  modalData,
  formErrors,
  onNestedChange,
  cityDropdownPosition,
}) => {
   const [countryStateCity, setCountryStateCity] = useState({
      country: [],
      state: [],
      city: [],
      countryLoading: true,
      stateLoading: false,
      cityLoading: false,
    });
  const address = modalData?.[addressKey] || {};
  const errors = (formErrors )?.[addressKey] || {};

const COUNTRY_FIELDS = "capital,name,alpha2Code,alpha3Code,emoji";
const CIS_BASE_URL =
  process.env.REACT_APP_CIS_BASE_URL 

  
async function getAllCountry(e) {
    try {      
      const countryResponse = await fetch(
        `${CIS_BASE_URL}/countries?all=true&fields=${COUNTRY_FIELDS}&sort=name&order=asc`,
        {
          method: "GET",
          redirect: "follow",
        }
      );
      const countryPayload = await countryResponse.json();
      const countryData = Array.isArray(countryPayload?.data)
        ? countryPayload.data?.map((item)=>({label:item?.name,value:item?.alpha2Code}))
        : [];
      if (address?.country?.value) {
        getAllCountryStates(address?.country?.value);
      }
      if (address?.state?.label) {
        getAllStatesCities(address?.state?.label);
      }
      setCountryStateCity((prev) => ({
        ...prev,
        country: countryData,
        countryLoading: false,
        state: [],
        city: [],
        stateLoading: false,
        cityLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setCountryStateCity((prev) => ({ ...prev, countryLoading: false }));
    }
  }
  async function getAllCountryStates(country) {
    try {
      setCountryStateCity((prev) => ({ ...prev, stateLoading: true }));
      const statesResponse = await fetch(
        `${CIS_BASE_URL}/countries/${country}/states?all=true&sort=name&order=asc`,
        {
          method: "GET",
          redirect: "follow",
        }
      );
      const statesPayload = await statesResponse.json();
      const statesData = Array.isArray(statesPayload?.data)
        ? statesPayload.data?.map((item)=>({label:item?.name,value:item?.state_code}))
        : [];
        
      setCountryStateCity((prev) => ({
        ...prev,
        state: statesData?.sort((a, b) => {
          const aName = a?.label;
          const bName = b?.label;
          if (aName < bName) {
            return -1;
          }
          if (aName > bName) {
            return 1;
          }
          return 0;
        }),
        stateLoading: false,
        city: [],
        cityLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setCountryStateCity((prev) => ({ ...prev, stateLoading: false }));
    }
  }
  async function getAllStatesCities(state) {
    try {
      setCountryStateCity((prev) => ({ ...prev, cityLoading: true }));
      const encodedStateIdentifier = encodeURIComponent(state || "");
      const citiesResponse = await fetch(
        `${CIS_BASE_URL}/states/${encodedStateIdentifier}/cities?all=true&sort=city_name&order=asc`,
        {
          method: "GET",
          redirect: "follow",
        }
      );
      const citiesPayload = await citiesResponse.json();
      const citiesData = Array.isArray(citiesPayload?.data)
        ? citiesPayload?.data?.map((item)=>({label:item?.city_name,value:item?.city_name}))
        : [];
        
      setCountryStateCity((prev) => ({
        ...prev,
        city: citiesData,
        cityLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setCountryStateCity((prev) => ({ ...prev, cityLoading: false }));
    }
  }
  useEffect(() => {
    getAllCountry();
  }, []);


// console.log("countryStateCity=>",countryStateCity);


  return (
    <>
      {/* street 1 & 2 */}
      <div className="grid grid-cols-2 items-start gap-3">
        <Field label="Street 1" required error={errors.street1}>
          <TextInput
            name="street1"
            required
            placeholder="Enter Street 1"
            value={address.street1 || ''}
            error={errors.street1}
            onChange={(e) => onNestedChange(addressKey, 'street1', e.target.value)}
          />
        </Field>
        <Field label="Street 2" error={errors.street2}>
          <TextInput
            name="street2"
            placeholder="Enter Street 2"
            value={address.street2 || ''}
            error={errors.street2}
            onChange={(e) => onNestedChange(addressKey, 'street2', e.target.value)}
          />
        </Field>
      </div>

      {/* country & state */}
      <div className="grid grid-cols-2 items-start gap-3">
        <Field
          label="Country"
          required
          labelAdornment={
            <LoadState loading={countryStateCity.countryLoading} error={countryStateCity.countryError} />
          }
          error={selectError(errors.country, 'Please select country')}
        >
          <MultiSelectDropdown
            search
            options={countryStateCity.country||[] }
            disabled={Boolean(countryStateCity.countryError || countryStateCity.countryLoading)}
            setSelected={(e) => {
              const value = e ;
              onNestedChange(addressKey, 'country', {
                label: value[0].label,
                value: value[0].value,
              });
              onNestedChange(addressKey, 'state', []);
              onNestedChange(addressKey, 'city', []);
              getAllCountryStates(value[0].value);
            }}
            selected={[
              {
                label: address.country?.label || '',
                value: address.country?.value || '',
              },
            ]}
          />
        </Field>

        <Field
          label="State"
          required
          labelAdornment={<LoadState loading={countryStateCity.stateLoading} error={countryStateCity.stateError} />}
          error={selectError(errors.state, 'Please select state')}
        >
          <MultiSelectDropdown
            search
            disabled={Boolean(
              !address.country?.value || countryStateCity.stateError || countryStateCity.stateLoading,
            )}
            options={countryStateCity.state||[] }
            setSelected={(e) => {
              const value = e ;
              onNestedChange(addressKey, 'state', {
                label: value?.[0].label,
                value: value?.[0].value,
              });
              onNestedChange(addressKey, 'city', '');
              getAllStatesCities(value?.[0].label);
            }}
            selected={[
              {
                label: address.state?.label || '',
                value: address.state?.value || '',
              },
            ]}
          />
        </Field>
      </div>

      {/* city & postal code */}
      <div className="grid grid-cols-2 items-start gap-3">
        <Field
          label="City"
          required
          labelAdornment={<LoadState loading={countryStateCity.cityLoading} error={countryStateCity.cityError} />}
          error={selectError(errors.city, 'Please select city')}
        >
          <MultiSelectDropdown
            search
            {...(cityDropdownPosition ? { position: cityDropdownPosition } : {})}
            options={countryStateCity.city||[] }
            disabled={Boolean(
              !address.state?.value || countryStateCity.cityError || countryStateCity.cityLoading,
            )}
            setSelected={(e) => {
              const value = e ;
              onNestedChange(addressKey, 'city', value?.[0].label);
            }}
            selected={[
              { label: address.city || '', value: address.city || '' },
            ]}
          />
        </Field>

        <Field label="Postal Code" required error={errors.postalCode}>
          <TextInput
            required
            name="postalCode"
            disabled={!address.city}
            placeholder="Enter Postal Code"
            value={address.postalCode || ''}
            error={errors.postalCode}
            onChange={(e) =>
              onNestedChange(addressKey, 'postalCode', e.target.value)
            }
          />
        </Field>
      </div>
    </>
  );
};

export default AddressFields;